import { get } from '../client';

/** Authenticated Places proxy — Google key stays on the backend. */
export const placesApi = {
  autocomplete: (params = {}) => get('/places/autocomplete', { params }),
  details: (params = {}) => get('/places/details', { params }),
};
